import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const Meta = () => {
    const location = useLocation();
    const [metaData, setMetaData] = useState({
        title: "CodeInputs – Web Development, APIs, Tools & Tech Solutions",
        ogtitle: "CodeInputs – Web Development, APIs, Tools & Tech Solutions",
        ogdescription: "CodeInputs offers web development, software & application development, custom API creation and integration, social media handling, graphics and logo designing services.",
        description: "CodeInputs offers web development, software & application development, custom API creation and integration, social media handling, graphics and logo designing services.",
        keywords: "web development, software development, application development, custom api, api integration, social media management, graphics design, logo design, digital development services",
        favicon: "/favicon.ico",
        ogurl:"https://www.codeinputs.com"
    });

    useEffect(() => {
        const fetchMeta = async () => {
            try {
                const response = await fetch("reactapi/api/codeinputs/get_page_detail", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ url: location.pathname }),
                });
                const data = await response.json();
                console.warn(data);
                setMetaData({
                    title: data.detail.title,
                    description: data.detail.description,
                    keywords: data.detail.keywords,
                    favicon: "/favicon.ico",
                    ogtitle: "CodeInputs – Web Development, APIs, Tools & Tech Solutions",
                    ogdescription: "CodeInputs offers web development, software & application development, custom API creation and integration, social media handling, graphics and logo designing services.",
                    ogurl:"https://www.codeinputs.com"
                });
            } catch (error) {
                console.error("Error fetching meta data:", error);
            }
        };

        fetchMeta();
    }, [location.pathname]);

    return (
        <Helmet>
            <title>{metaData.title}</title>
            <meta name="description" content={metaData.description} />
            <meta name="keywords" content={metaData.keywords} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0" /> 
            <meta name="google-adsense-account" content="ca-pub-8417600594136797"/>
            <meta property="og:title" content={metaData.ogtitle}/>
            <meta property="og:description" content={metaData.ogdescription}/>
            <meta property="og:url" content={metaData.ogurl}/>
            <link rel="icon" type="image/png" href={metaData.favicon} />
            <link rel="preload" as="image" href="/graphics/images/heroimages.svg" type="image/svg"/>
            <link rel="canonical" href="https://codeinputs.com"/>
            
        </Helmet>
    );
};

export default Meta;
